<template>
  <div class="key-row column is-12">
    <div class="columns data-row">
      <div
        class="column top-column"
        :class="{ 'is-10': isExpired, 'is-8': isRevoked, 'is-9': isActive }"
      >
        <div class="columns">
          <div class="column is-2">
            {{ data.name }}
          </div>
          <div class="column is-3">
            {{ data.id }}
          </div>
          <div class="column is-3">
            <span
              v-for="(scope, index) in data.scopes"
              class="scope-span"
              :key="index"
            >
              {{ scope }}
            </span>
          </div>
          <div class="column is-2">
            {{ formatDate(data.expires_at) }}
          </div>
          <div class="column is-2">
            {{ formatDate(data.created_at) }}
          </div>
        </div>
      </div>
      <div
        class="column top-column"
        :class="{ 'is-2': isExpired, 'is-4': isRevoked, 'is-3': isActive }"
      >
        <div class="columns">
          <div
            class="column"
            :class="{ 'is-12': isExpired, 'is-6': isRevoked, 'is-8': isActive }"
          >
            <div>{{ data.created_by_id }}</div>
            <div>{{ data.created_by_email }}</div>
          </div>
          <div class="column is-4" v-if="isActive">
            <button class="button revoke-button" @click="revokeKey(data.id)">
              Revoke
            </button>
          </div>
          <div class="column is-6" v-if="isRevoked">
            <div>{{ data.revoked_by_id }}</div>
            <div>{{ data.revoked_by_email }}</div>
            <div>{{ formatDate(data.revoked_at) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from 'store';
import { format } from 'date-fns';
import { mapState } from 'vuex';

export default {
  name: 'KeyRow',

  props: {
    data: {
      type: Object,
    },
    currentTab: {
      type: String,
    },
  },

  computed: {
    isActive() {
      return this.currentTab === 'active';
    },
    isRevoked() {
      return this.currentTab === 'revoked';
    },
    isExpired() {
      return this.currentTab === 'expired';
    },
  },

  methods: {
    formatDate(date) {
      return format(date, 'YYYY/MM/DD hh:mm a');
    },

    revokeKey() {
      store.commit('api_key/setKeyToRevoke', this.data);
      this.$emit('open-revoke-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.button {
  margin: 0;
  padding: 0.5rem 1.25rem;
  background-color: #ff7272;
  color: $white;
}
</style>
